<mat-button-toggle-group #group="matButtonToggleGroup" (change)="onChange($event)" [value]="lc(value)"
  hideSingleSelectionIndicator="true">
  @for (choice of choices; track choice) {
    <mat-button-toggle [disableRipple]="true" [value]="lc(choice.value)">
      <span class="round {{choice.color}} {{choice.icon || choice.label ? 'tight' : ''}}">
        @if (choice.icon) {
          <mat-icon [ngClass]="{'large-icon': choice.largeIcon}" [svgIcon]="choice.icon"></mat-icon>
        }

        @if (choice.swatch) {
          <div class="swatch" [style.background-color]="choice.swatch"></div>
        }

        @if (choice.imageSwatch) {
          <div class="swatch" [style.background-image]="'url(' + choice.imageSwatch + ')'"></div>
        }

        @if (choice.label) {
          <div class="label" [ngClass]="[choice.label.class]" [innerHtml]="choice.label.text"></div>
        }
      </span>
      @if (choice.caption) {
        <div class="caption" [innerHtml]="choice.caption"></div>
      }
    </mat-button-toggle>
  }
</mat-button-toggle-group>

<ng-content></ng-content>
